/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AccountsRequestBuilderNavigationMetadata, AccountsRequestBuilderRequestsMetadata, type AccountsRequestBuilder } from './accounts';
// @ts-ignore
import { CreditcardsRequestBuilderNavigationMetadata, CreditcardsRequestBuilderRequestsMetadata, type CreditcardsRequestBuilder } from './creditcards';
// @ts-ignore
import { CurrenciesRequestBuilderNavigationMetadata, CurrenciesRequestBuilderRequestsMetadata, type CurrenciesRequestBuilder } from './currencies';
// @ts-ignore
import { DebtforecastsRequestBuilderNavigationMetadata, type DebtforecastsRequestBuilder } from './debtforecasts';
// @ts-ignore
import { ExchangerateRequestBuilderRequestsMetadata, type ExchangerateRequestBuilder } from './exchangerate';
// @ts-ignore
import { InvestmentaccountsRequestBuilderNavigationMetadata, InvestmentaccountsRequestBuilderRequestsMetadata, type InvestmentaccountsRequestBuilder } from './investmentaccounts';
// @ts-ignore
import { LoansRequestBuilderNavigationMetadata, LoansRequestBuilderRequestsMetadata, type LoansRequestBuilder } from './loans';
// @ts-ignore
import { MortgagesRequestBuilderNavigationMetadata, MortgagesRequestBuilderRequestsMetadata, type MortgagesRequestBuilder } from './mortgages';
// @ts-ignore
import { PromotionalbalancesRequestBuilderNavigationMetadata, PromotionalbalancesRequestBuilderRequestsMetadata, type PromotionalbalancesRequestBuilder } from './promotionalbalances';
// @ts-ignore
import { ScheduledtransactionsRequestBuilderNavigationMetadata, ScheduledtransactionsRequestBuilderRequestsMetadata, type ScheduledtransactionsRequestBuilder } from './scheduledtransactions';
// @ts-ignore
import { SessionRequestBuilderRequestsMetadata, type SessionRequestBuilder } from './session';
// @ts-ignore
import { StatusRequestBuilderRequestsMetadata, type StatusRequestBuilder } from './status';
// @ts-ignore
import { apiClientProxifier, ParseNodeFactoryRegistry, SerializationWriterFactoryRegistry, type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type RequestAdapter } from '@microsoft/kiota-abstractions';
// @ts-ignore
import { FormParseNodeFactory, FormSerializationWriterFactory } from '@microsoft/kiota-serialization-form';
// @ts-ignore
import { JsonParseNodeFactory, JsonSerializationWriterFactory } from '@microsoft/kiota-serialization-json';
// @ts-ignore
import { MultipartSerializationWriterFactory } from '@microsoft/kiota-serialization-multipart';
// @ts-ignore
import { TextParseNodeFactory, TextSerializationWriterFactory } from '@microsoft/kiota-serialization-text';

/**
 * Instantiates a new {@link MoneyCheckerApiClient} and sets the default values.
 * @param requestAdapter The request adapter to use to execute the requests.
 */
// @ts-ignore
export function createMoneyCheckerApiClient(requestAdapter: RequestAdapter) {
    if (requestAdapter === undefined) {
        throw new Error("requestAdapter cannot be undefined");
    }
    const serializationWriterFactory = requestAdapter.getSerializationWriterFactory() as SerializationWriterFactoryRegistry;
    const parseNodeFactoryRegistry = requestAdapter.getParseNodeFactory() as ParseNodeFactoryRegistry;
    const backingStoreFactory = requestAdapter.getBackingStoreFactory();
    
    if (parseNodeFactoryRegistry.registerDefaultDeserializer) {
        parseNodeFactoryRegistry.registerDefaultDeserializer(JsonParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(TextParseNodeFactory, backingStoreFactory);
        parseNodeFactoryRegistry.registerDefaultDeserializer(FormParseNodeFactory, backingStoreFactory);
    }
    
    if (serializationWriterFactory.registerDefaultSerializer) {
        serializationWriterFactory.registerDefaultSerializer(JsonSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(TextSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(FormSerializationWriterFactory);
        serializationWriterFactory.registerDefaultSerializer(MultipartSerializationWriterFactory);
    }
    
    const pathParameters: Record<string, unknown> = {
        "baseurl": requestAdapter.baseUrl,
    };
    return apiClientProxifier<MoneyCheckerApiClient>(requestAdapter, pathParameters, MoneyCheckerApiClientNavigationMetadata, undefined);
}
/**
 * The main entry point of the SDK, exposes the configuration and the fluent API.
 */
export interface MoneyCheckerApiClient extends BaseRequestBuilder<MoneyCheckerApiClient> {
    /**
     * The accounts property
     */
    get accounts(): AccountsRequestBuilder;
    /**
     * The creditcards property
     */
    get creditcards(): CreditcardsRequestBuilder;
    /**
     * The currencies property
     */
    get currencies(): CurrenciesRequestBuilder;
    /**
     * The debtforecasts property
     */
    get debtforecasts(): DebtforecastsRequestBuilder;
    /**
     * The exchangerate property
     */
    get exchangerate(): ExchangerateRequestBuilder;
    /**
     * The investmentaccounts property
     */
    get investmentaccounts(): InvestmentaccountsRequestBuilder;
    /**
     * The loans property
     */
    get loans(): LoansRequestBuilder;
    /**
     * The mortgages property
     */
    get mortgages(): MortgagesRequestBuilder;
    /**
     * The promotionalbalances property
     */
    get promotionalbalances(): PromotionalbalancesRequestBuilder;
    /**
     * The scheduledtransactions property
     */
    get scheduledtransactions(): ScheduledtransactionsRequestBuilder;
    /**
     * The session property
     */
    get session(): SessionRequestBuilder;
    /**
     * The status property
     */
    get status(): StatusRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const MoneyCheckerApiClientUriTemplate = "{+baseurl}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MoneyCheckerApiClientNavigationMetadata: Record<Exclude<keyof MoneyCheckerApiClient, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    accounts: {
        requestsMetadata: AccountsRequestBuilderRequestsMetadata,
        navigationMetadata: AccountsRequestBuilderNavigationMetadata,
    },
    creditcards: {
        requestsMetadata: CreditcardsRequestBuilderRequestsMetadata,
        navigationMetadata: CreditcardsRequestBuilderNavigationMetadata,
    },
    currencies: {
        requestsMetadata: CurrenciesRequestBuilderRequestsMetadata,
        navigationMetadata: CurrenciesRequestBuilderNavigationMetadata,
    },
    debtforecasts: {
        navigationMetadata: DebtforecastsRequestBuilderNavigationMetadata,
    },
    exchangerate: {
        requestsMetadata: ExchangerateRequestBuilderRequestsMetadata,
    },
    investmentaccounts: {
        requestsMetadata: InvestmentaccountsRequestBuilderRequestsMetadata,
        navigationMetadata: InvestmentaccountsRequestBuilderNavigationMetadata,
    },
    loans: {
        requestsMetadata: LoansRequestBuilderRequestsMetadata,
        navigationMetadata: LoansRequestBuilderNavigationMetadata,
    },
    mortgages: {
        requestsMetadata: MortgagesRequestBuilderRequestsMetadata,
        navigationMetadata: MortgagesRequestBuilderNavigationMetadata,
    },
    promotionalbalances: {
        requestsMetadata: PromotionalbalancesRequestBuilderRequestsMetadata,
        navigationMetadata: PromotionalbalancesRequestBuilderNavigationMetadata,
    },
    scheduledtransactions: {
        requestsMetadata: ScheduledtransactionsRequestBuilderRequestsMetadata,
        navigationMetadata: ScheduledtransactionsRequestBuilderNavigationMetadata,
    },
    session: {
        requestsMetadata: SessionRequestBuilderRequestsMetadata,
    },
    status: {
        requestsMetadata: StatusRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
